module.exports = __webpack_public_path__ + "static/img/4.20aa17f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand/4.png
// module id = qmsZ
// module chunks = 45